import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';

// Healthcare Directives checklist screen
import { HealthcareDirectivesChecklistScreen } from '../../screens/checklists/HealthcareDirectivesChecklistScreen';

// Advance Directive screens (existing)
import { AdvanceDirectiveDataScreen } from '../../screens/tasks/finalCare/advanceDirective/AdvanceDirectiveDataScreen';
import { AdvanceDirectiveInputScreen } from '../../screens/tasks/finalCare/advanceDirective/AdvanceDirectiveInputScreen';
import { AdvanceDirectiveIntroScreen } from '../../screens/tasks/finalCare/advanceDirective/AdvanceDirectiveIntroScreen';
import { AdvanceDirectiveIntroScreen2 } from '../../screens/tasks/finalCare/advanceDirective/AdvanceDirectiveIntroScreen2';
import { AdvanceDirectiveLockedScreen } from '../../screens/tasks/finalCare/advanceDirective/AdvanceDirectiveLockedScreen';
import { AdvanceDirectiveLockUnlockScreen } from '../../screens/tasks/finalCare/advanceDirective/AdvanceDirectiveLockUnlockScreen';
import { AdvanceDirectiveUnlockedScreen } from '../../screens/tasks/finalCare/advanceDirective/AdvanceDirectiveUnlockedScreen';
import { AdvanceDirectiveExplainScreen } from '../../screens/tasks/finalCare/advanceDirective/AdvanceDirectiveExplainScreen';

// Medical POA Preferences screens (existing)
import { MedicalPOAPreferencesDataScreen } from '../../screens/tasks/finalCare/medicalPOA/MedicalPOAPreferencesDataScreen';
import { MedicalPOAPreferencesInputScreen } from '../../screens/tasks/finalCare/medicalPOA/MedicalPOAPreferencesInputScreen';
import { MedicalPOAPreferencesIntroScreen } from '../../screens/tasks/finalCare/medicalPOA/MedicalPOAPreferencesIntroScreen';
import { MedicalPOAPreferencesLockedScreen } from '../../screens/tasks/finalCare/medicalPOA/MedicalPOAPreferencesLockedScreen';
import { MedicalPOAPreferencesLockUnlockScreen } from '../../screens/tasks/finalCare/medicalPOA/MedicalPOAPreferencesLockUnlockScreen';
import { MedicalPOAPreferencesUnlockedScreen } from '../../screens/tasks/finalCare/medicalPOA/MedicalPOAPreferencesUnlockedScreen';

// DNR Preferences screens (existing)
import { DNRPreferencesDataScreen } from '../../screens/tasks/finalCare/dnrPreferences/DNRPreferencesDataScreen';
import { DNRPreferencesInputScreen } from '../../screens/tasks/finalCare/dnrPreferences/DNRPreferencesInputScreen';
import { DNRPreferencesIntroScreen } from '../../screens/tasks/finalCare/dnrPreferences/DNRPreferencesIntroScreen';
import { DNRPreferencesLockedScreen } from '../../screens/tasks/finalCare/dnrPreferences/DNRPreferencesLockedScreen';
import { DNRPreferencesLockUnlockScreen } from '../../screens/tasks/finalCare/dnrPreferences/DNRPreferencesLockUnlockScreen';
import { DNRPreferencesUnlockedScreen } from '../../screens/tasks/finalCare/dnrPreferences/DNRPreferencesUnlockedScreen';

// HIPAA Authorization screens
import { HIPAAAuthorizationDataScreen } from '../../screens/tasks/healthcareDirectives/hipaaAuthorization/HIPAAAuthorizationDataScreen';
import { HIPAAAuthorizationInputScreen } from '../../screens/tasks/healthcareDirectives/hipaaAuthorization/HIPAAAuthorizationInputScreen';
import { HIPAAAuthorizationIntroScreen } from '../../screens/tasks/healthcareDirectives/hipaaAuthorization/HIPAAAuthorizationIntroScreen';
import { HIPAAAuthorizationLockedScreen } from '../../screens/tasks/healthcareDirectives/hipaaAuthorization/HIPAAAuthorizationLockedScreen';
import { HIPAAAuthorizationLockUnlockScreen } from '../../screens/tasks/healthcareDirectives/hipaaAuthorization/HIPAAAuthorizationLockUnlockScreen';
import { HIPAAAuthorizationUnlockedScreen } from '../../screens/tasks/healthcareDirectives/hipaaAuthorization/HIPAAAuthorizationUnlockedScreen';

const Stack = createNativeStackNavigator();

const HealthcareDirectivesStackNavigator: React.FC = () => {
  return (
    <Stack.Navigator
      screenOptions={{
        headerShown: false,
      }}
    >
      <Stack.Screen name="HealthcareDirectivesChecklist" component={HealthcareDirectivesChecklistScreen} />

      {/* Advance Directive screens */}
      <Stack.Screen name="AdvanceDirectiveIntro" component={AdvanceDirectiveIntroScreen} />
      <Stack.Screen name="AdvanceDirectiveIntro2" component={AdvanceDirectiveIntroScreen2} />
      <Stack.Screen name="AdvanceDirectiveInput" component={AdvanceDirectiveInputScreen} />
      <Stack.Screen name="AdvanceDirectiveExplain" component={AdvanceDirectiveExplainScreen} />
      <Stack.Screen name="AdvanceDirectiveLockUnlock" component={AdvanceDirectiveLockUnlockScreen} />
      <Stack.Screen name="AdvanceDirectiveUnlocked" component={AdvanceDirectiveUnlockedScreen} />
      <Stack.Screen name="AdvanceDirectiveLocked" component={AdvanceDirectiveLockedScreen} />
      <Stack.Screen name="AdvanceDirectiveData" component={AdvanceDirectiveDataScreen} />

      {/* Medical POA Preferences screens */}
      <Stack.Screen name="MedicalPOAPreferencesIntro" component={MedicalPOAPreferencesIntroScreen} />
      <Stack.Screen name="MedicalPOAPreferencesInput" component={MedicalPOAPreferencesInputScreen} />
      <Stack.Screen name="MedicalPOAPreferencesLockUnlock" component={MedicalPOAPreferencesLockUnlockScreen} />
      <Stack.Screen name="MedicalPOAPreferencesUnlocked" component={MedicalPOAPreferencesUnlockedScreen} />
      <Stack.Screen name="MedicalPOAPreferencesLocked" component={MedicalPOAPreferencesLockedScreen} />
      <Stack.Screen name="MedicalPOAPreferencesData" component={MedicalPOAPreferencesDataScreen} />

      {/* DNR Preferences screens */}
      <Stack.Screen name="DNRPreferencesIntro" component={DNRPreferencesIntroScreen} />
      <Stack.Screen name="DNRPreferencesInput" component={DNRPreferencesInputScreen} />
      <Stack.Screen name="DNRPreferencesLockUnlock" component={DNRPreferencesLockUnlockScreen} />
      <Stack.Screen name="DNRPreferencesUnlocked" component={DNRPreferencesUnlockedScreen} />
      <Stack.Screen name="DNRPreferencesLocked" component={DNRPreferencesLockedScreen} />
      <Stack.Screen name="DNRPreferencesData" component={DNRPreferencesDataScreen} />

      {/* HIPAA Authorization screens */}
      <Stack.Screen name="HIPAAAuthorizationIntro" component={HIPAAAuthorizationIntroScreen} />
      <Stack.Screen name="HIPAAAuthorizationInput" component={HIPAAAuthorizationInputScreen} />
      <Stack.Screen name="HIPAAAuthorizationLockUnlock" component={HIPAAAuthorizationLockUnlockScreen} />
      <Stack.Screen name="HIPAAAuthorizationUnlocked" component={HIPAAAuthorizationUnlockedScreen} />
      <Stack.Screen name="HIPAAAuthorizationLocked" component={HIPAAAuthorizationLockedScreen} />
      <Stack.Screen name="HIPAAAuthorizationData" component={HIPAAAuthorizationDataScreen} />
    </Stack.Navigator>
  );
};

export default HealthcareDirectivesStackNavigator;
